module.exports = __webpack_public_path__ + "img/heading_sns.ffaa81c7.png";